import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonSize, ButtonStyle } from '../buttons/button.type';

interface DateFilterOption {
  value: string;
  label: string;
}

@Component({
  selector: 'app-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss'],
  standalone: false,
})
export class DateRangePickerComponent {
  @Input() label: string = 'Filtrer du';

  @Input() showFilterSelect = false;
  @Input() filterOptions: DateFilterOption[] = [];
  @Input() selectedFilter: string | null = null;

  @Input() startDate!: string;
  @Input() endDate!: string;

  @Input() minDate!: string;
  @Input() maxDate!: string;

  @Output() startDateChange = new EventEmitter<string>();
  @Output() endDateChange = new EventEmitter<string>();
  @Output() filterChange = new EventEmitter<string>();

  protected readonly ButtonSize = ButtonSize;

  protected readonly ButtonStyle = ButtonStyle;

  onStartDateChange(date: string) {
    this.startDate = date;
    this.startDateChange.emit(date);

    if (this.endDate && this.endDate < this.startDate) {
      this.endDate = this.startDate;
      this.endDateChange.emit(this.endDate);
    }
  }

  onEndDateChange(date: string) {
    this.endDate = date;
    this.endDateChange.emit(date);
  }

  onFilterChange(value: string) {
    this.selectedFilter = value;
    this.filterChange.emit(value);
  }

  clearDates() {
    this.startDate = '';
    this.endDate = '';
  }
}
